import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var ExpandableLabelsContainer = function ExpandableLabelsContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = classnames('ptr-ExpandableLabelsContainer', className);
  var labelsCount = React.Children.count(children);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: React.Children.map(children, function (child, i) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        zIndex: labelsCount - i
      }));
    })
  });
};

ExpandableLabelsContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};
export default ExpandableLabelsContainer;